<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import ButtonCallTo from '@/components/common/buttons/ButtonCallTo.vue'
import ButtonMailTo from '@/components/common/buttons/ButtonMailTo.vue'
import IconWithTooltip from '@/components/common/ui/IconWithTooltip.vue'
import { DevicePhoneMobileIcon, EyeIcon, PencilIcon } from '@heroicons/vue/24/outline'

const props = defineProps(['params'])

const row = computed(() => props.params?.data)

const contact = computed(() => row.value?.contact)
const company = computed(() => row.value?.company)
const todoStatus = computed(() => row.value?.status || 'PENDING')

const phone = ref<string | undefined>()
const mobile = ref<string | undefined>()
const email = ref<string | undefined>()
const partnerId = ref<number | undefined>()
const contactId = ref<number | undefined>()

onMounted(() => {
  // Priorité au contact, sinon company
  if (contact.value) {
    phone.value = contact.value.phone
    mobile.value = contact.value.mobile
    email.value = contact.value.email
    partnerId.value = contact.value.company?.referenceExterne
    contactId.value = contact.value.referenceExterne
  } else if (company.value) {
    phone.value = company.value.phone
    email.value = company.value.email
    partnerId.value = company.value.referenceExterne
    contactId.value = undefined
  }
})

function onView() {
  if (props.params?.onClickView) {
    props.params.onClickView(row.value)
  }
}

// Détermine si on peut modifier (seulement si status = PENDING)
const canEdit = computed(() => todoStatus.value === 'PENDING')
const viewButtonText = computed(() => canEdit.value ? 'Modifier' : 'Voir')
const viewButtonIcon = computed(() => canEdit.value ? PencilIcon : EyeIcon)
</script>

<template>
  <div class="flex items-center justify-end gap-2 w-full">
    <!-- Call Fixed -->
    <div v-if="phone" class="w-fit">
      <ButtonCallTo :partner-id="partnerId" :contact-id="contactId" :phone="phone" :tooltip-position="params?.tooltipPosition || 'top'" />
    </div>

    <!-- Call Mobile -->
    <div v-if="mobile" class="w-fit">
      <ButtonCallTo
        :partner-id="partnerId"
        :contact-id="contactId"
        :phone="mobile"
        :icon="DevicePhoneMobileIcon"
        :tooltip-position="params?.tooltipPosition || 'top'"
      />
    </div>

    <!-- Mail -->
    <div v-if="email" class="w-fit">
      <ButtonMailTo :email="email" :tooltip-position="params?.tooltipPosition || 'top'" />
    </div>

    <!-- View/Edit -->
    <div class="w-fit">
      <IconWithTooltip :text="viewButtonText" :tooltip-position="params?.tooltipPosition || 'top'" @click="onView">
        <component :is="viewButtonIcon" class="h-4 w-4" />
      </IconWithTooltip>
    </div>
  </div>
</template>
